<template>
  <div>
    <h2 class="content-block-title">{{ title }}</h2>

    <dx-data-grid
      v-if="!loading"
      class="dx-card content-block"
      :data-source="dataSource"
      key-expr="id"
      :focused-row-index="0"
      :show-borders="false"
      :focused-row-enabled="true"
      :column-auto-width="true"
      :column-hiding-enabled="true"
    >
      <dx-paging :page-size="20" />
      <dx-pager 
        :show-page-size-selector="true" 
        :show-info="true" 
        :allowed-page-sizes="[5, 10, 20, 30, 50]" 
      />
      <dx-filter-row :visible="true" />

      <dx-column data-field="name" caption="Domain Name" />
      <dx-column caption="URL" data-field="url" cell-template="urlCellTemplate" />
      <dx-column data-field="content" caption="IP Address" />
      <dx-column data-field="proxied" caption="Proxied" />
      <dx-column data-field="proxiable" caption="Proxiable" />
      <dx-column data-field="type" caption="Record Type" />
      <dx-column data-field="ttl" caption="TTL" />
      <dx-column data-field="created_on" caption="Created On" data-type="date" />
      <dx-column data-field="modified_on" caption="Modified On" data-type="date" />
      <dx-column data-field="comment" caption="Comment" />

      <!-- Template for URL -->
      <template #urlCellTemplate="{ data }">
        <a
          :href="data.value"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ data.value.replace(/^https?:\/\//, '') }}
        </a>
      </template>
      
    </dx-data-grid>

    <div v-if="loading" class="loading-overlay">
      <DxLoadIndicator :height="60" :width="60" />
    </div>
  </div>
</template>


<script>
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxPager,
  DxFilterRow
} from 'devextreme-vue/data-grid';

import { DxLoadIndicator } from 'devextreme-vue/load-indicator';
import axios from 'axios';  

export default {
  name: 'DnsRecordsGrid',
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxPager,
    DxFilterRow,
    DxLoadIndicator
  },
  data() {
    return {
      title: 'Cloudflare DNS Records',
      loading: true,
      dataSource: []
    };
  },
  mounted() {
    this.loadDnsRecords();
  },
  methods: {
    async loadDnsRecords() {
      try {
        const response = await axios.get('/api/internal/cloudflare/dns-records');
        // const json = await res.json();
        // this.dataSource = json;
        this.dataSource = Array.isArray(response.data) ? response.data : [];
      } catch (err) {
        console.error('Error loading data:', err);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.loading-overlay {
  position: absolute;
  top: 100px;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 10;
}

.tag-pill {
  display: inline-block;
  padding: 3px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  color: white;
}

.tag-ok {
  background-color: #4caf50;
}

.tag-warning {
  background-color: #ff9800;
}

.tag-expired {
  background-color: #f44336;
}

.tag-error {
  background-color: #d32f2f;
  max-width: 250px;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
